import { z } from "zod";

/**
 * Apify tool auth — stored in AgentExternalTool.auth when type = APIFY.
 *
 * Always this exact shape — hardcoded in apify-store-fetch.service.ts.
 * Users provide their own Apify API key via ToolCredentials.apikey.
 * If no credential exists, the backend falls back to the platform Apify token.
 */
export const ApifyAuthSchema = z.object({
  type: z.literal("user_http"),
  authorization_type: z.enum(["basic", "bearer", "custom"])
});

export type ApifyAuth = z.infer<typeof ApifyAuthSchema>;
